import config from 'shared/config';
import { FunnelType, WirePage } from 'scenes/common/types';
import { RetrieveFunnelState } from 'scenes/retrieve/types';

export const toWirePage = (
  state: RetrieveFunnelState,
  cid?: string,
  qid?: string
): WirePage => ({
  pageName: 'gi:retrieve-quote:landing-page',
  pageUrl: `${window.location.origin}${config.junctionPath}/${FunnelType.Retrieve}/${state.step}`,
  siteSection: FunnelType.Retrieve,
  siteServer: window.location.hostname,
  stepName: 'retrieve:retrieve-quote:landing-page',
  timeStamp: `${new Date().valueOf()}`,
  colesCampaignCode: cid ?? '',
  campaignCodePrefilled: qid ?? '',
});
